import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { SbModalState } from '../modal-state.service';
import { ErrorOptions } from '../modal.model';
import { ToasterService, ToastType } from '../../../toaster/toaster.service';
import { TranslateService } from '@ngx-translate/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { StringConcatBuiltinFn } from '@angular/compiler-cli/src/ngtsc/partial_evaluator/src/builtin';

@Component({
  selector: 'sb-uncaught-modal',
  templateUrl: './sb-uncaught-modal.component.html',
  styleUrls: ['./sb-uncaught-modal.component.scss'],
  standalone: false,
})
export class SbUncaughtModalComponent implements OnInit {
  private readonly clipboard = inject(Clipboard);

  @Input() templateId: string;

  options: ErrorOptions<any>;
  copied = signal(false);

  ngOnInit() {
    this.options = this.state.options.get(this.templateId) as ErrorOptions<any>;
  }

  constructor(private readonly state: SbModalState) {}

  public copyToClipboard(): void {
    const copiedErrorText: string =
      'Statuscode: ' +
      this.options.statuscode +
      '\r\n' +
      'Message: ' +
      this.options.message +
      '\r\n' +
      'Endpoint: ' +
      this.options.url +
      '\r\n' +
      'Errorcode: ' +
      this.options.errorcode +
      '\r\n' +
      'Erroridentifier: ' +
      this.options.errorstring +
      '\r\n';
    this.clipboard.copy(copiedErrorText);
    this.copied.set(true);
    setTimeout(() => {
      this.copied.set(false);
    }, 2000); // Reset after 2 seconds
  }

  ok() {
    this.state.modals.get(this.templateId).close('OK');
  }
}
